<template>
  <zb-select
    ref='zbSelect'
    :action="plansAction"
    v-bind="$attrs"
    :model-value="modelValue"
    @update:model-value="handleModelValueUpdate"
  >
    <template v-for="(_, slot) in $slots" :key="slot" #[slot]="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zb-select>
</template>

<script>
import ZbSelect from '@/components/zoom-ui-plus/select/select.vue';

export default {
  name: 'CycleSelect',
  props: {
    modelValue: [String, Number, Boolean, Array],
    plans: Array,
    action: Function,
  },
  emits: ['update:modelValue'],
  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item.billing_cycle === oldVal);
      const newPlan = this.plans.find(item => item.billing_cycle === val);
      return this.action(oldPlan, newPlan);
    },
    handleModelValueUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    focus() {
      this.$refs.zbSelect.focus();
    }
  },
  components: {
    ZbSelect,
  },
}
</script>
